import { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';

import { updateDsrAction } from '../actions/dsr-actions';

import { Box, Flex } from "@chakra-ui/react";
import PageLoader from '../../global/components/helper-components/components/PageLoader';
import LaunchdeckButton from '../../global/components/helper-components/components/LaunchdeckButton';
import LaunchdeckModal from '../../global/components/helper-components/components/LaunchdeckModal';


function DeleteActionModal({
  dsrId,
  mapCategoryId,
  actionItemToEdit,
  showModal,
  handleCloseDeleteActionModal,
  // Actions
  updateDsrAction,
  // Redux
  updateDsrActionOutcome
}) {

  // UX Management
  const [showLoader, setShowLoader] = useState(false)


  useEffect(() => {
    if (updateDsrActionOutcome) {
      setShowLoader(false)
      handleCloseDeleteActionModal()
    }

  }, [updateDsrActionOutcome, handleCloseDeleteActionModal]);


  // Functions
  function handleClickDeleteAction() {
    const { actionId } = actionItemToEdit || {};

    const updateActionMetadata = {
      dsrId,
      mapCategoryId,
      actionId,
      event: "delete-action"
    }

    setShowLoader(true);
    updateDsrAction(updateActionMetadata)

  }

  function renderDeleteActionModalContent() {
    if (showLoader) {
      return (
        <Box w="100%" align="center" >
          <Box px='1em'>
            <PageLoader />
          </Box>
        </Box>
      )
    }

    if (!showLoader) {
      return (
        <Box w='100%' p='1em 1.8em'>
          <Flex w="100%" fontSize='0.875em' color='brandDark.500'>
            Are you sure about deleting this action task?
          </Flex>

          <Flex mt='1.625em' w='100%' justify={['center', 'flex-end']}>
            <LaunchdeckButton bg='brandPink.500' w={['100%', 'auto']} color='gray.50' fontSize='0.8em' py='0.4em' onClick={() => handleClickDeleteAction()} label='Yes, delete' />
          </Flex>
        </Box>
      )
    }
  }


  // Render
  if (!showModal) {
    return null;
  }

  if (showModal) {
    return (
      <LaunchdeckModal
        title={'Delete action item'}
        handleCloseModal={handleCloseDeleteActionModal}
        showModal={true}
        maxW='35em'
      >
        {renderDeleteActionModalContent()}
      </LaunchdeckModal>
    )
  }
}

function mapStateToProps(state) {
  return {
    updateDsrActionOutcome: state.updateDsrActionOutcome.results.data
  };
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updateDsrAction
    },
    dispatch,
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DeleteActionModal));